module.exports = new __parcel__URL__("CineBrick.219ac439.avif").toString();